var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-4"},[_c('inline-router-link',{attrs:{"to":{name: 'journalDetails', params: {id: _vm.applicationId, orgid: _vm.handledOrgId}}}},[_vm._v(" "+_vm._s(_vm.$t("previewApplicationPageStrings.labels.toJournal", [_vm.handledOrgName]))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }